


















































































































































































































































































































































































import Tabbar from '@/components/tabbar/tabbar.vue'
import monent from 'moment'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getDates, isPhoneNumber } from '@/utils/utils'
import {
  ProductList,
  insertMation,
  shopServer,
  barnds,
  carSeries,
  yearbran,
  model,
  orderDetection,
} from "@/api/api.config";
import moment from "moment";
import { nextTick } from "vue/types/umd";
import { Logger } from "html2canvas/dist/types/core/logger";
interface Parms {
  [key: string]: any
}
@Component({
  components: {
    Tabbar,
  },
})
export default class Home extends Vue {
vShow(vShow: any) {
throw new Error('Method not implemented.');
}
  tm: any = "";
  changeVals: any = "";
  isShow: any = true;
  columnList: any = [];
  changeDates: any = "";
  Times: any = "";
  columns: any = [];
  startTime: any = "";
  endTime: any = "";
  hidden: Boolean = false;
  activedId: any = "";
  toast: any;
  enterpriseName: any = "";
  prodype: any = "";
  showTitle: boolean = false;
  // 控制是否显示
  show = false
  showTime = false
  showPicker = false
  product: any = {
    connectName: '',
    connectNumber: '',
    reserveTime: '',
    productIds: [],
    productNames: [],
    enterpriseId: '',
    // 品牌
    brand: '',
    carSeriesName: '',
    carTypeName: '',
    carTypeId: '',
  }
  serverlist: any = []
  // 时间
  currentDate: any = ''
  changeDate: any = ''
  checked = false
  list: any = []
  num = 0
  title = ''
  userInfo: Parms = {}
  orderId: any = ''
  icon: any = '\ue900'
  // 图片数据
  iphone: any = [
    {
      img: require('../../assets/images/pic_huishou3.png'),
      active: require('../../assets/images/pic_huishou0.png'),
    },
    {
      img: require('../../assets/images/pic_jiance1.png'),
      active: require('../../assets/images/pic_jiance3.png'),
    },
    {
      img: require('../../assets/images/pic_jiance2 .png'),
      active: require('../../assets/images/pic_huishou1.png'),
    },
  ]
  shows = false
  fieldValue = ''
  cascaderValue = ''
  // 选项列表，children 代表子选项，支持多级嵌套
  options: any = [
    {
      text: '浙江省',
      value: '330000',
      children: [{ text: '杭州市', value: '330100' }],
    },
    {
      text: '江苏省',
      value: '320000',
      children: [{ text: '南京市', value: '320100' }],
    },
  ]
  carbarnd: any = []
channeObj: any;
  // async barnds() {
  //   let result = await barnds();
  //   this.options = result.data.data.map((item: any) => {
  //     return {
  //       text: item.name,
  //       value: "barnd" + item.id,
  //       children: [],
  //     };
  //   });
  // }

  // onChange({ value, selectedOptions, tabIndex }: any) {
  //   console.log("value:" + value);

  //   console.log("tabIndex:" + tabIndex);
  //   if (tabIndex == 0) {
  //     value = value.replace("carSeries", "");
  //     carSeries(value.replace("barnd", "")).then((res) => {
  //       var arr = res.data.data.map((el: any) => {
  //         var arr1 = el.carSeries.map((item: any) => {
  //           return {
  //             text: item.name,
  //             value: "carSeries" + item.id,
  //             children: [],
  //           };
  //         });
  //         return {
  //           text: el.carMfrs.name,
  //           value: el.carMfrs.id,
  //           children: arr1,
  //         };
  //       });

  //       this.options = this.options.map((item: any) => {
  //         if (item.value == value) {
  //           item.children = arr;
  //         }
  //         return item;
  //       });
  //     });
  //   } else if (tabIndex == 2) {
  //     console.log("value2:" + value);
  //     yearbran(value.replace("carSeries", "")).then((res) => {
  //       let arr = res.data.data.map((item: any) => {
  //         return {
  //           text: item,
  //           value: value + "-" + item,
  //           children: [],
  //         };
  //       });
  //       this.options = this.options.map((item: any) => {
  //         item.children.forEach((el: any) => {
  //           el.children.forEach((ele: any) => {
  //             if (ele.value == value) {
  //               ele.children = arr;
  //             }
  //           });
  //         });
  //         return item;
  //       });
  //     });
  //   } else if (tabIndex == 3) {
  //     let val = value.split("-")[0];
  //     model(
  //       val.replace("carSeries", ""),
  //       selectedOptions[selectedOptions.length - 1].text
  //     ).then((res) => {
  //       let arr = res.data.data.map((item: any) => {
  //         return {
  //           text: item.name,
  //           value: item.id,
  //         };
  //       });
  //       this.options = this.options.map((item: any) => {
  //         item.children.forEach((el: any) => {
  //           el.children.forEach((ele: any) => {
  //             if (ele.value == val) {
  //               ele.children.forEach((e: any) => {
  //                 if (e.text == selectedOptions[selectedOptions.length - 1].text) {
  //                   e.children = arr;
  //                 }
  //               });
  //             }
  //           });
  //         });
  //         return item;
  //       });
  //     });
  //   }
  // }
  // onFinish({ selectedOptions }: any) {
  //   this.shows = false;
  //   this.fieldValue = selectedOptions.map((option: any) => option.text).join("/");
  //   for (let i = 0; i < selectedOptions.length; i++) {
  //     console.log(selectedOptions[i]);
  //     this.product.brand = selectedOptions[0].text;
  //     this.product.carTypeName = selectedOptions[4].text;
  //     this.product.carTypeId = selectedOptions[4].value;
  //   }
  //   console.log(this.product.brand, this.product.carTypeName, this.product.carTypeId);
  // }

  created() {
    this.prodype = "";
    this.title = "home";
    this.toast("加载完成");
    console.log(this.$route.query);
    // this.product.vin = this.$route.query.vin;
    // this.product.drivingLicenseImg = this.$route.query.img;
    // this.product.sign = this.$route.query.signatureImg;
  }
  activated() {
    // this.hidshow = true;
    this.product.brand = this.$route.query.brand
    this.product.carSeriesName = this.$route.query.carSeriesName
    this.product.carTypeName = this.$route.query.carTypeName
    this.product.carTypeId = this.$route.query.carTypeId
    // this.$router.push("/home");
    // this.fieldValue =
    //   this.product.brand +
    //     this.product.carSeriesName +
    //     this.product.carTypeName +
    //     this.product.carTypeId || "";
    this.fieldValue = this.product.carTypeName || "";
    console.log(this.fieldValue, "测试");
    this.orderId = this.$route.query.orderId;
    console.log(this.$route.query);
    if (this.orderId) {
      this.orderDetection()
    }
    let pinpais: any = sessionStorage.getItem('pinpai')
    if (pinpais === null) {
      return
    } else {
      let pinpaies: any = JSON.parse(pinpais)
      this.product.carTypeId = pinpaies.id
      this.prodype = pinpaies.name
    }
    this.activedId = this.$route.query.id
  }

  // 选中事件
  changeFn() {
    this.changeDate = this.currentDate
  }
  // 点击弹出
  showPopup() {
    this.show = false
    console.log('打开了时间')
    this.$nextTick(() => {
      if (!this.product.enterpriseId) {
        this.$toast('请先选择门店')
      } else {
        this.show = true
      }
    })
  }
  // 点击预约
  addorder() {
    let itemObj = localStorage.getItem('channeObj')
    if (itemObj) {
      this.channeObj = JSON.parse(itemObj)
    }
    let productId: any = []
    let productName: any = []
    this.list.forEach((item: any) => {
      if (item.flag) {
        productId.push(item.productId)
        productName.push(item.productName)
      }
    });
    console.log(this.product);
    this.product.productIds = productId;
    this.product.productNames = productName;
    let { connectName, enterpriseId, connectNumber, productIds, productNames } =
      this.product;
    this.$router.push({
      query: {
        product: this.product,
      },
    })
    if (!this.fieldValue) {
      return this.$toast.fail('请选择品牌')
    }
    if (!isPhoneNumber(connectNumber)) {
      return this.$toast.fail('手机号错误')
    }
    if (!this.checked) {
      return this.$toast.fail('请勾选')
    } else if (
      connectName === '' ||
      enterpriseId === '' ||
      connectNumber === '' ||
      productIds === []
    ) {
      return this.$toast.fail('请填写内容')
    } else {
      // this.insertList();
      this.$router.push({
        name: 'Index',
        query: {
          product: this.product,
          prodype: this.prodype,
          enterpriseName: this.enterpriseName,
        },
      })
      this.product = {
        connectName: '',
        connectNumber: '',
        carTypeId: '',
        reserveTime: '',
        productIds: [],
        productNames: [],
        enterpriseId: '',
        brand: '',
        carTypeName: '',
      }
      this.fieldValue = ''
      this.cascaderValue = ''
      this.prodype = ''
      this.enterpriseName = ''
      this.list.forEach((item: any) => {
        item.flag = false
        ;(this.$refs as any).inputNode.forEach((el: any) => {
          el.checked = false
        })
      })
      this.checked = false
    }
  }
  // insertList() {
  //   insertMation(this.product).then((res) => {
  //     if (res.data.code === "0") {
  //       this.$toast.success("请上传行驶本");
  //       this.$router.push({
  //         name: "Index",
  //       });
  //       this.product = {
  //         connectName: "",
  //         connectNumber: "",
  //         carTypeId: "",
  //         reserveTime: "",
  //         productIds: [],
  //         productNames: [],
  //         enterpriseId: "",
  //       };
  //       this.prodype = "";
  //       this.enterpriseName = "";
  //       this.list.forEach((item: any) => {
  //         item.flag = false;
  //         this.$refs.inputNode.forEach((el: any) => {
  //           el.checked = false;
  //         });
  //       });
  //       this.checked = false;
  //     } else {
  //       this.$toast.fail(res.data.message);
  //     }
  //     // console.log(res);
  //   });
  // }

  // 选择车牌
  car() {
    this.$router.push('/brand')
  }
  // 产品数据
  ProductLists() {
    ProductList().then((res) => {
      this.list = res.data.neProductEntities
    })
  }
  // 门店数据
  shopServerList() {
    shopServer({}).then((res) => {
      this.serverlist = res.data.enterpriseEntities
    })
  }
  mounted() {
    const currentDate = moment();
    const year = currentDate.format("YYYY");
    const month = currentDate.format("MM");
    const day = currentDate.format("DD");
    this.tm = year + "/" + month + "/" + day;
    window.onresize = () => {
      if (
        navigator.userAgent.indexOf('Android') > 1 ||
        navigator.userAgent.indexOf('Adr') > -1
      ) {
        this.isShow = !this.isShow
      }
    }
    this.ProductLists()
    this.shopServerList()
    // this.barnds();
    sessionStorage.removeItem('pinpai')
  }

  destroyed() {
    //页面销毁前要记得这个监听消除掉;
    window.onresize = null
  }
  // 门店
  shop() {
    this.showPicker = true
  }
  // 选中产品id
  checkbox(item: any, e: any) {
    // if (item.flag) {
    //   this.product.productIds.splice(0,item.productId);
    //   this.product.productNames.splice(item.productName,1);
    // } else {
    //   this.product?.productIds?.push(item.productId);
    //   this.product?.productNames?.push(item.productName);
    // }

    this.$set(item, 'flag', e.target.checked)
    // console.log(this.product);
  }
  // 门店确定按钮
  onConfirm(value: any) {
    this.columns = [];
    this.enterpriseName = value.enterpriseName;
    this.product.enterpriseId = value.enterpriseId;
    this.startTime = value.startTime;
    this.endTime = value.endTime;
    this.timeSeg(this.startTime, this.endTime);
    this.showPicker = false;
  }

  onConfirmTime(value: any) {
    this.Times = moment(value).format("yyyy/MM/DD");
    this.show = false;
    this.showTime = true;
  }

  toearch(index: any) {
    if (index === 2) {
      this.showTitle = true;
      this.$dialog
        .alert({
          title: "提示",
          message: "系统升级维护中,暂不支持该功能 !",
        })
        .then(() => {
          this.showTitle = false;
        });
    } else {
      this.$router.push({
        name: "Index",
        query: { id: index },
      });
    }
  }

  onConfirms(value: any, index: any) {
    this.product.reserveTime = this.Times.replace(/\//g, '-') + ' ' + value

    console.log(this.product.reserveTime)
    // this.changeDate = this.changeDate + (value +0);
    this.showTime = false
  }
  onChanges(picker: any, value: any, index: any) {
    // this.showTime = false;
    // this.$toast(`当前值：${value}, 当前索引：${index}`);
  }
  onCancels() {
    this.showTime = false
    // this.$toast("取消");
  }

  timeSeg(startT: any, endT: any, interval = 30) {
    let starTime = monent(startT, "HH:mm");
    let endTime = monent(endT, "HH:mm");
    let diff = endTime.diff(starTime, "minutes");
    let num = Math.floor(diff / interval);
    for (let i = 1; i <= num; i++) {
      let timeFrom = starTime.clone().add((i - 1) * interval, "minutes");
      let timeTo = starTime.clone().add(i * interval, "minutes");
      let minutes = timeFrom.minutes();
      let hour = timeFrom.hour();
      let time = moment().format("HH:mm");
      this.columns.push(timeTo.format("HH:mm"));
      this.columnList = this.columns.filter((item: any) => item > time);
    }
    if (!this.columns.find((item: any) => item === startT)) {
      this.columns.unshift(startT)
    }
    this.columnList;
    console.log(this.columnList, "选择的时间");
  }

  timeSegs(startT: any, endT: any, interval = 30) {
    let starTime = monent(startT, "HH:mm");
    let endTime = monent(endT, "HH:mm");
    let diff = endTime.diff(starTime, "minutes");
    let num = Math.floor(diff / interval);
    for (let i = 1; i <= num; i++) {
      let timeFrom = starTime.clone().add((i - 1) * interval, "minutes");
      let timeTo = starTime.clone().add(i * interval, "minutes");
      let minutes = timeFrom.minutes();
      let hour = timeFrom.hour();
      let time = moment().format("HH:mm");
      this.columns.push(timeTo.format("HH:mm"));
      // .filter((item: any) => item > time);
      this.columnList = this.columns;
    }
    if (!this.columns.find((item: any) => item === startT)) {
      this.columns.unshift(startT);
    }
    this.columnList;
    console.log(this.columnList, "选择的时间");
  }
  // 再来一单
  async orderDetection() {
    let result = await orderDetection({ orderId: this.orderId })
    this.product = result.data.data
    for (let i = 0; i < this.serverlist.length; i++) {
      if (this.serverlist[i].enterpriseId == this.product.enterpriseId) {
        console.log(this.serverlist[i].enterpriseName)
        this.enterpriseName = this.serverlist[i].enterpriseName
        this.timeSeg(this.serverlist[i].startTime, this.serverlist[i].endTime)
      }
    }
  }
  // 跳转品牌页面
  toBrand() {
    this.$router.push({
      path: '/brand',
    })
  }
  @Watch("Times")
  change(val: any) {
    console.log(val, "监视数据");
    this.changeVals = val;
    if (val == this.tm) {
      this.timeSeg(this.startTime, this.endTime);
    } else {
      this.timeSegs(this.startTime, this.endTime);
    }
  }
}
